import { newE2EPage } from "@stencil/core/testing";

describe("switch-input", () => {
    it("should render with label and match snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-switch-input name="test-switch" desc="Description" label="Label"></ux-switch-input>`);
        const el = await page.find("ux-switch-input");
        await page.waitForChanges();
        expect(el).toHaveClass("hydrated");
        expect(el).toMatchSnapshot();
    });

    it("should render without label and match snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-switch-input name="test-switch" desc="Description"></ux-switch-input>`);
        const el = await page.find("ux-switch-input");
        await page.waitForChanges();
        expect(el).toHaveClass("hydrated");
        expect(el).toMatchSnapshot();
    });

    it("should render enabled", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-switch-input name="test-switch" desc="Description" checked></ux-switch-input>`);
        const el = await page.find("ux-switch-input");
        await page.waitForChanges();
        const btn = await page.find("ux-switch-input >>> button");
        expect(btn.getAttribute("role")).toEqual("switch");
        expect(btn.getAttribute("aria-checked")).toEqual("true");
        expect(el).toMatchSnapshot();
    });

    it("should render disabled", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-switch-input name="test-switch" desc="Description"></ux-switch-input>`);
        const el = await page.find("ux-switch-input");
        await page.waitForChanges();
        const btn = await page.find("ux-switch-input >>> button");
        expect(btn.getAttribute("role")).toEqual("switch");
        expect(btn.getAttribute("aria-checked")).toEqual("false");
        expect(el).toMatchSnapshot();
    });

    it("should emit uxSwitch event when clicked", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-switch-input name="test-switch" label="Label"></ux-switch-input>`);
        const switchEvent = await page.spyOnEvent("uxChange");
        const el = await page.find("ux-switch-input.hydrated");
        await page.waitForChanges();
        const btn = await page.find("ux-switch-input >>> label");
        await btn.click();
        expect(switchEvent).toHaveReceivedEventDetail(true);
        expect(el.getAttribute("checked")).not.toBeNull();
        await btn.click();
        expect(switchEvent).toHaveReceivedEventDetail(false);
        expect(el.getAttribute("checked")).toBeNull();
    });
});
